import { action, computed, observable } from 'mobx';
import { HenshuUser } from './persist/IHenshuPersistLayer';


export interface IHenshuApp {
    isLoggedIn: boolean;
    isEditing: boolean;
    setEditMode(mode: boolean): void;
    editMode: boolean;
    setUser(user: HenshuUser|null): void;
    user: HenshuUser|any;
}


export default class HenshuApp implements IHenshuApp {

    @observable
    editMode: boolean = false;

    @action
    setEditMode(mode: boolean) {
        this.editMode = mode;
    }

    @observable
    user: HenshuUser|null = null;

    @action
    setUser(user: HenshuUser|null) {
        this.user = user;
    }

    @computed
    get isLoggedIn() {
        return this.user !== null;
    }

    @computed
    get isEditing() {
        return this.isLoggedIn && this.editMode;
    }
   
}
